import { createUseStyles } from 'react-jss'

export const style = {
  svg: {
    display: 'block',
    overflow: 'visible',

    // override normalize defaults for embedded content
    '&:not(:root)': {
      overflow: 'visible'
    }
  },
  splitChartContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > svg:first-child': {
      transform: 'translateX(-12px)'
    },
    '& > svg:last-child': {
      transform: 'translateX(12px)'
    }
  }
}

export const useStyles = createUseStyles(style)
